export let InfoElements = [
  {
    title: "Patient Name",
    field: "patientName",
    color: "#000",
    type: "string",
  },
  {
    title: "Product Code",
    field: "productName",
    color: "#000",
    type: "string",
  },
  {
    title: "Policy Cover",
    field: "policyVariant",
    color: "#000",
    type: "string",
  },
  {
    title: "Procedure Name",
    field: "procedureName",
    color: "#000",
    type: "string",
  },
  {
    title: "Procedure Code",
    field: "procedureCode",
    color: "#000",
    type: "string",
  },
  {
    title: "Hospital Name",
    field: "hospitalName",
    color: "#000",
    type: "string",
  },

  {
    title: "Created on",
    field: "dateCreated",
    color: "#000",
    type: "date",
  },
  {
    title: "Digitization Data Received from Vitraya",
    field: "responseSentTime",
    color: "#000",
    type: "date",
  },
  {
    title: "Room Type",
    field: "roomType",
    color: "#000",
    type: "string",
  },
  {
    title: "Last Re-Run",
    field: "dateUpdated",
    color: "#000",
    type: "date",
  },

  {
    title: "Enhancement Status",
    field: "enhancementStatus",
    color: "#000",
    type: "enhancement",
  },
  {
    title: "Claim Status",
    field: "adjudicationStatus",
    color: "#000",
    type: "claimStatus",
  },
  {
    title: "Reverse Feed Status",
    field: "reverseFeedStatus",
    color: "#000",
    type: "string",
  },
  {
    title: "Status of Claim when sent for Digitization",
    field: "claimStatus",
    color: "#000",
    type: "string_with_underscores",
  },
  {
    title: "Amount Saved",
    field: "amountDeductedInPercent",
    color: "#000",
    type: "amount",
  },
  {
    title: "Module Status",
    field: "combinedStatus",
    color: "#000",
    type: "moduleStatus",
  },
  {
    title: "Bill Parsed Accuracy",
    field: "tariffMatchPercentage",
    color: "#000",
    type: "accuracy",
  },
  {
    title: "Out Of Scope Hospital",
    field: "outOfScopeHospital",
    color: "#000",
    type: "scope",
  },
  {
    title: "Claim Type",
    field: "claimTransactionType",
    color: "#000",
    type: "string",
  },
  {
    title: "COI Number",
    field: "coiNumber",
    color: "#000",
    type: "coiNumber",
  },
  {
    title: "MPH Number",
    field: "mphNumber",
    color: "#000",
    type: "mphNumber",
  },
  {
    title: "Product Name",
    field: "productPlan",
    color: "#000",
    type: "product",
  },
  {
    title: "Vitraya STP Response",
    field: "stpStatus",
    color: "#000",
    type: "stpStatus",
  }
];
